import { debugLog } from '@ui-common/utils/helpers'
import { removeSessionStorageItem, setSessionStorageItem } from '@ui-common/utils/storage'
import * as R from 'remeda'
import { Actor, AnyMachineSnapshot, AnyStateMachine, InputFrom, StateFrom, StateValueFrom } from 'xstate'

import { getInitialState } from '../utils/xstateUtils'
import { useActor } from './useActor'

export const getMachineStorageKey = (machineId: string): string => `${machineId}-state`

export const usePersistingActor = <TMachine extends AnyStateMachine>(
  machine: TMachine,
  shouldHydrateState: (state: StateFrom<TMachine>) => boolean = () => false,
  onActorSnapshot: (stateValue: StateValueFrom<TMachine>) => unknown = R.doNothing(),
  initialContext: InputFrom<TMachine> | null = null,
): Actor<TMachine> => {
  const sessionStorageKey = getMachineStorageKey(machine.id)
  const initialState = getInitialState(sessionStorageKey, shouldHydrateState)

  const actor = useActor(
    machine,
    {
      ...(initialState ? { snapshot: initialState } : undefined),
      ...(initialContext ? { input: initialContext } : undefined),
    },
    {
      next: (snapshot: AnyMachineSnapshot) => {
        debugLog(`State (${machine.id}): ${JSON.stringify(snapshot)}`)
        window.history.pushState({ page: snapshot.value }, 'unused', window.location.href)
        const persistedState = actor.getPersistedSnapshot()
        setSessionStorageItem(sessionStorageKey, JSON.stringify(persistedState))
        onActorSnapshot(snapshot.value)
      },
      complete: () => {
        removeSessionStorageItem(sessionStorageKey)
      },
    },
  )

  return actor
}
